/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_enable_in_depth_search_label24 = /** @type {(inputs: {}) => string} */ () => {
	return `Enable in-depth Search`
};

const fr_enable_in_depth_search_label24 = /** @type {(inputs: {}) => string} */ () => {
	return `Activer la recherche en profondeur`
};

const de_enable_in_depth_search_label24 = /** @type {(inputs: {}) => string} */ () => {
	return `Tiefensuche aktivieren`
};

const es_enable_in_depth_search_label24 = /** @type {(inputs: {}) => string} */ () => {
	return `Habilitar búsqueda en profundidad`
};

const it_enable_in_depth_search_label24 = /** @type {(inputs: {}) => string} */ () => {
	return `Abilita la ricerca approfondita`
};

const ar_enable_in_depth_search_label24 = /** @type {(inputs: {}) => string} */ () => {
	return `تمكين البحث المتعمق`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const enable_in_depth_search_label24 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.enable_in_depth_search_label24(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("enable_in_depth_search_label24", locale)
	if (locale === "en") return en_enable_in_depth_search_label24(inputs)
	if (locale === "fr") return fr_enable_in_depth_search_label24(inputs)
	if (locale === "de") return de_enable_in_depth_search_label24(inputs)
	if (locale === "es") return es_enable_in_depth_search_label24(inputs)
	if (locale === "it") return it_enable_in_depth_search_label24(inputs)
	return ar_enable_in_depth_search_label24(inputs)
};
export { enable_in_depth_search_label24 as "ENABLE_IN_DEPTH_SEARCH_LABEL" }